import "../styles/Explanation.css"; // Import the CSS file

import Button from "../components/atoms/Button";
import React from "react";

const Explanation = ({ data, onClose, onNext, onBack, currentIndex, totalQuestions }) => {
	return (
		<div className='explanation-container'>
			<div className='explanation-header'>
				<div className='explanation-header-text'>
					<div className='section-module-question-header'>
						<span className='bold'>{data.section}</span> - Question {data.no}
					</div>
					<div className='answer-type'>
						<span className='blue'>Question Type : {data.questionType}</span>
					</div>
				</div>
				<div className='explanation-navigation-buttons'>
					<Button
						label='Back'
						onClick={onBack}
						className='navigation-button'
						disabled={currentIndex === 0}
					/>
					<Button
						label='Next'
						onClick={onNext}
						className='navigation-button'
						disabled={currentIndex === totalQuestions - 1}
					/>
					<div className='score-page-close-button' onClick={onClose}>
						X
					</div>
				</div>
			</div>
			<div className='line'></div>
			<div className='explanation-content'>
				<div className='explanation-content-col1'>
					{data.question.IMAGE.url && data.question.IMAGE.position === "TOP" && (
						<div>
							<img src={data.question.IMAGE.url} alt='question image' />
						</div>
					)}
					<div
						dangerouslySetInnerHTML={{
							__html: data?.question.TEXT.html,
						}}></div>
					{data.question.IMAGE.url && data.question.IMAGE.position === "BOTTOM" && (
						<div>
							<img src={data.question.IMAGE.url} alt='question image' />
						</div>
					)}
					<div>
						<label
							style={{
								fontFamily: "Helvetica",
								fontSize: "1rem",
								color: "#000000",
								fontWeight: "400",
								textAlign: "start",
							}}
							dangerouslySetInnerHTML={{
								__html: data?.question.ADDITIONAL_TEXT,
							}}></label>
					</div>
					<div className='options'>
						{data.questionType === "multiple-choice" ? (
							<div className='options-list'>
								{data.options?.map((option, i) => (
									<div
										key={i}
										className='option-container'
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: "10px",
											gap: "10px",
											width: "100%",
											borderRadius: "8px",
											border:
												option.ID === data.correctAnswer
													? "1px solid blue"
													: "",
										}}>
										<button
											className='option-btn'
											style={{
												flex: 1,
												display: "flex",
												alignItems: "center",
												border:
													data.yourChoice === option.ID &&
													option.ID === data.correctAnswer
														? "1px solid #08BD80"
														: data.yourChoice === option.ID &&
														  option.ID !== data.correctAnswer
														? "1px solid red"
														: "",
												borderRadius: "8px",
												cursor: "pointer",
												margin: "2px",
											}}>
											<span
												className={`option-id ${
													option.ID === data.yourChoice ? "" : ""
												}`}>
												{option.ID}
											</span>
											<span
												className='option-text'
												dangerouslySetInnerHTML={{
													__html: option?.TEXT,
												}}></span>
										</button>
									</div>
								))}
							</div>
						) : (
							<div class='free-form-input'>
								<div class='input-box'>
									<input type='text' value={data.yourChoice} disabled={true} />
								</div>
							</div>
						)}
						{data.questionType === "multiple-choice" ? (
							<div className='options-legend'>
								<div className='choice-container'>
									<span
										className={
											data.yourChoice === data.correctAnswer
												? "circle green-background"
												: "circle red-background"
										}></span>
									<span
										className={
											data.yourChoice === data.correctAnswer
												? "label green-label"
												: "label red-label"
										}>
										Your Choice
									</span>
								</div>
								<div className='choice-container'>
									<span className='circle blue-background'></span>
									<span className='label blue-label'>Correct Choice</span>
								</div>
							</div>
						) : (
							<div></div>
						)}
					</div>
				</div>
				<div className='explanation-content-col2'>
					<span style={{ fontWeight: 700, fontSize: "20px" }}>Explanation</span>
					<div
						dangerouslySetInnerHTML={{
							__html: data?.explanation.html,
						}}></div>
				</div>
			</div>
			<div className='learn-more'>
				<Button label='Learn Relevant Concept' className='learn-more-button' />
				<Button label='Practice Relevant Questions' className='learn-more-button' />
			</div>
		</div>
	);
};

export default Explanation;
